<!--
Deadlines and grades screen.

Assignments are shown in this screen. Assignments which have not yet been submitted are under the 'Deadlines' tab,
and submitted ones are under the 'Grades' tab. (This means you can have assignments which have not yet been graded
in the grades tab.)

The first time the screen is loaded, the grades and any individual components are loaded and stored in IndexedDB
(i.e. on the client). Subsequently the grades will be pulled from IndexedDB. If the data is ever stale the user can
click the Refresh button at the bottom of the page. Data in IndexedDB is there forever or until the user logs out or
cleans out application data.

SORTING
The assignments are sorted by the due dates provided, earliest first.
It was requested that assignments with individual components be sorted by the date of the earliest of these
components but it significantly increases the overall complexity for not much gain (and we fetch the individual
components separately anyway, *after* the sorting's already been done...)

FILTERS
Filtering has made this screen more complex
- The UserFilters and Drawer components work together. The user selects the filter criteria in the Drawer,
      and the UserFilters panel indicates which criteria are being filtered on. *This* *component* actually does
      the filtering.
- Any issues with filtering, have a look in the collectFilters() and applyFilters() functions in the AFFilterCommon.js mixin.
- The object fetched from the GradesService is called 'deadlines' but contains both Deadlines and Grades.

OVERDUE ITEMS
Note that an item can be shown as 'overdue' in this screen by virtue of it not yet being submitted and it being in the past.
If its status in Moodle is NOT 'overdue' as well, that status (e.g. 'not submitted') will be shown, and
the red indicator dot on the 'Deadlines' tab will not be shown.
</template>

<script>
export default {

}
</script>

<style>

</style>

@author ab557z
-->
<template>
  <div id="contain" class="container">
    <Nav name="Deadlines &amp; Grades" />
    <Spinner ref="spinner" />
    <div>
      <ul style="background-color: #f7f7f7;" class="nav nav-tabs">
        <li style="width:50% !important"
          @click="filterEvents('deadlines')"
          class="eventNav" :class="{ dateActive: selected[0] }">
          Deadlines<GradeCheck v-bind:key="deadlines.length" :initDeadlines="deadlines" initCheckType="overdue" /></li>
        <li style="width:50% !important"
          @click="filterEvents('grades')"
          class="eventNav" :class="{ dateActive: selected[1] }">Grades</li>
      </ul>
    </div>
    <div v-if="loading">Please wait while we fetch deadlines and grades ...</div>
    <UserFilters
        :message="filterMessage"
        :filters="filters"
        :filterDates="filterDates"
        @filterClicked="f => { loadFilter(f) }"
        />
    <div>
      <!-- <template v-if="1==2">  -->
        <template v-for="(deadline, index) in filteredDeadlines">

       <Grade v-if="!loading && inGradesTab (deadline, subAssessments[deadline.id])" v-show="showGrades" v-bind:key="deadline.id + '_grade'"
        :deadline="deadline" :id="'order_by_' + index" :pos="index"/>

        <Deadline v-if="!loading && inDeadlinesTab (deadline, subAssessments[deadline.id])" v-show="showDeadlines" v-bind:key="deadline.id + '_deadline'"
            :deadline="deadline" :id="'order_by_' + index" :pos="index"
            @eventRender="onEventRender()" />
      </template>
      <template v-if="num_of.deadlines == 0 && showDeadlines">
        <main class="p-2">
          <div class="nothingToDisplay">You have no deadlines to display</div>
        </main>      </template>
      <template v-if="num_of.grades == 0 && showGrades">
        <main class="p-2">
          <div class="nothingToDisplay">You have no grades to display</div>
        </main>
      </template>
    </div>
    <div id="pusher"></div>
<div class="refreshButtonContainer">
          <button class="refreshButton" @click=refreshGrades() :disabled="!canRefresh()" >Refresh</button>
</div>
    <Drawer :showCloseButton="true" :key="showDrawer" :toggle="showDrawer" :title="drawerTitle" @doCancel=cancelFilterChanges>
      <table class="af-drawer-list-options">
      <tr v-if="drawerContents.length < 2" class="no-options"><td>Can't filter on this criteria - there are fewer than 2 options available!</td></tr>
      <tr v-else v-bind:key="index" v-for="(opt, index)  in drawerContents">
        <td><input type="checkbox" v-model="filters[drawerSelecting].selected[criteria(opt, index)]" ></td>
        <td>{{ upToFirst(opt.displayName, '|') }}</td>
      </tr>
      </table>
      <!-- show if date is selected -->
      <div v-if="drawerSelecting == 'dates' && filters.dates.selected[2] == true">
        <table>
          <tr><td>From:</td><td>To:</td></tr>
          <tr><td><input type='date' v-model="filterDates.from"></td><td><input type='date' v-model="filterDates.to"></td></tr>
        </table>
      </div>
      <div v-if="drawerError != ''" class="drawerError">{{ drawerError }}</div>
      <div class="af-drawer-button-div">
        <button class="af-button-apply" :disabled="noFilterOptionsSelected(drawerSelecting)" @click="doFiltering()">Apply Filter</button>
      </div>
      <div class="af-drawer-button-div">
        <button class="af-button-clear" @click="clearFilters()">Clear</button>
      </div>
    </Drawer>
    <Footer active="notifications" />
  </div>
</template>
<!-- 1 -->
<script>
import axios from 'axios'
import Deadline from '@/components/af/Deadline.vue'
import Grade from '@/components/af/Grade.vue'
import GradeCheck from '@/components/af/GradeCheck.vue'
import Footer from '@/components/FooterMenu.vue'
import AssFeedCommon from '@/mixins/AssFeedCommon.js'
import AFFilterCommon from '@/mixins/AFFilterCommon.js'
import IDBCommon from '@/mixins/IDBCommon.js'
import StringUtil from '@/mixins/StringUtil.js'
import UserFilters from '@/components/UserFilters.vue'
import Drawer from '@/components/Drawer.vue'
import * as lst from '@/components/localStorage.js'

export default {
  name: 'AF',
  components: {
    Deadline,
    Grade,
    GradeCheck,
    UserFilters,
    Drawer,
    Footer
  },
  computed: {
  },
  data () {
    return {
      loading: true,
      /* note, you can have an assignment show up in both tabs so don't do any maths with these numbers */
      num_of: {
        deadlines: 0,
        grades: 0
      },
      gradesChanged: false,
      serverFetchTS: 0,
      deadlines: [],
      subAssessments: {},
      filteredDeadlines: [],
      drawerTitle: 'None',
      drawerSelecting: 'course',
      drawerContents: [],
      drawerError: '',
      selected: [true, false],
      showDeadlines: true,
      showGrades: false,
      showDrawer: false,
      filterMessage: "Showing all classes you're currently enrolled in",
      filterDates: {
        from: '',
        to: ''
      },
      filterDatesSnapshot: {},
      filterSnapshot: {},
      filters: {
        'dates': {
          'order': 0,
          'selected': {},
          'fmap': {}
        },
        'course': {
          'order': 1,
          'displayName': 'Moodle course',
          'alternateField': 'shortname',
          'selected': {},
          'fmap': {}
        },
        'topic': {
          'order': 2,
          'selected': {},
          'fmap': {}
        },
        'status': {
          'order': 3,
          'selected': {},
          'fmap': {}
        },
        'type': {
          'order': 4,
          'selected': {},
          'fmap': {}
        }
      }
      /* these filters are used in UserFilters and Drawer */
    }
  },
  mixins: [AssFeedCommon, AFFilterCommon, StringUtil, IDBCommon],
  mounted () {
    let requestedTab = this.$route.params.tab
    let reqtab = 0
    if (typeof requestedTab !== 'undefined') {
      // console.log('requestedTab = ' + requestedTab)
      reqtab = parseInt(this.$route.params.tab)
    }
    if (reqtab == 0) {
      this.filterEvents('deadlines')
    } else if (reqtab == 1) {
      this.filterEvents('grades')
    }

    if (this.idbSupported()) {
      this.fetchGradesFromIdb()
    } else {
      this.fetchGradesFromServer()
    }
  },
  methods: {
    noFilterOptionsSelected (filterName) {
      const selFilters = this.filters[filterName].selected
      let ret = true
      for (const ob of Object.keys(selFilters)) {
        console.log(ob)
        if (selFilters[ob] == true) {
          ret = false // at lease one filter option is selected
        }
      }
      return ret
    },
    canRefresh () {
      const d = new Date()
      const MINS_1 = 60000
      return (d.getTime() - this.serverFetchTS > MINS_1)
    },
    refreshGrades () {
      this.loading = true
      this.deadlines = []
      this.subAssessments = {}
      this.fetchGradesFromServer()
    },
    async fetchGradesFromIdb () {
      const guid = lst.getUserGuid()
      let gi = await this.getGuidInfo(guid)
      if (typeof gi !== 'undefined' && 'grades' in gi) {
        this.deadlines = gi['grades']
        console.log('fetched deadlines internally')
        // check for sub assessments too
        if ('grades-components' in gi) {
          this.subAssessments = {}
          const sa = gi['grades-components']
          for (const x of Object.keys(sa)) {
            this.subAssessments[x] = sa[x]
          }
        }
        this.processDeadlines()
      } else {
        console.log('idb data does not contain grades - fetching from backend')
        this.fetchGradesFromServer()
      }
    },
    async fetchGradesFromServer () {
      axios.get('/timetable/grades/dashboard')
        .then(response => {
          console.log(' --> received grades from backend')
          let dl = response.data

          // fetch sub assessment data if any
          for (let deadline of dl) {
            if (deadline.status == 'individual components') {
              console.log(' -> need to fetch components for ' + deadline.id)
              this.subAssessments[deadline.id] = 'tbc'
            }
          }

          if (this.idbSupported()) {
            this.storeInIdb(dl, 'grades')
          }

          this.deadlines = dl
          let d = new Date()
          this.serverFetchTS = d.getTime()
          this.processDeadlines()
          this.getSubAssessments()
        })
    },
    async getSubAssessments () {
      //       axios.get('/timetable/grades/subassessments?subId=' + subId)
      let requests = []
      let rid = []
      for (let cid in this.subAssessments) {
        requests.push(axios.get('/timetable/grades/subassessments?subId=' + cid))
        rid.push(cid)
      }
      console.log('subsequent requests needed: ' + requests.length)
      if (requests.length > 0) {
        axios.all(requests).then(axios.spread((...responses) => {
          console.log(' ---> received individual component data from backend')
          for (let r = 0; r < responses.length; r++) {
            const res = responses[r]
            const resdata = res.data
            // console.log('assessment id is ' + resdata.id)
            // console.log('assessment data is ')
            // console.log(resdata)
            this.subAssessments[rid[r]] = resdata
          }

          // NOW we can store sub assessment data.
          if (this.idbSupported()) {
            console.log('storing individual component data')
            this.storeInIdb(this.subAssessments, 'grades-components')
          }
        })).catch(errors => {
          console.log(new Error('problem fetching individual components'))
          for (let e of errors) {
            console.log(e.toString())
          }
        })
      }
    },
    processDeadlines () {
      // due dates of 0 won't have headers
      this.deadlines.forEach(a => {
        if (a.duedate === 0) {
          a.duedate = Number.MAX_SAFE_INTEGER
        }
      })
      this.deadlines.sort((a, b) => { return a.duedate - b.duedate })
      this.deadlines.forEach(a => {
        if (a.duedate === Number.MAX_SAFE_INTEGER) {
          a.duedate = 0
        }
      })

      this.num_of = { deadlines: 0, grades: 0 }
      for (let dg of this.deadlines) {
        // this loop is just to check if there is no (unfiltered) content in each tab
        const sa = this.subAssessments[dg.id]
        const whichTab = this.whichTab(dg, sa)
        if (whichTab == 'grades') {
          this.num_of.grades++
        } else if (whichTab == 'deadlines') {
          this.num_of.deadlines++
        } else if (whichTab == 'both') {
          this.num_of.grades++
          this.num_of.deadlines++
        }
      }

      this.filteredDeadlines = this.deadlines
      this.loading = false
    },
    async storeInIdb (dl, key) {
      console.log('storing in indexeddb for ' + key)
      // console.log(dl)
      // don't forget, you need to specify guid
      let storeHash = {
        'guid': lst.getUserGuid()
      }
      storeHash[key] = dl // use the given key name, not 'key'. thanks, javascript :-P
      this.storeDb(storeHash, true) // don't delete data already there
    },
    checkBounds () {
      // don't allow more than one option to be selected if we're looking at dates
      this.drawerError = ''
      if (this.drawerSelecting == 'dates') {
        // we can't just count the keys in .selected
        // because if you de-select a checkbox its key stays in the map :-P
        const selectedDateFilters = this.filters['dates'].selected
        let optSel = Object.keys(selectedDateFilters).filter((o) => selectedDateFilters[o] == true).length
        // console.log(optSel + ' option(s) selected')
        if (optSel > 1) {
          this.drawerError = 'Please select only one date filtering option'
          return false
        } else if (optSel == 1 && this.filters['dates'].selected[2]) {
          if (this.filterDates.from == '' || this.filterDates.to == '') {
            this.drawerError = 'Please select a from and a to date'
            return false
          }
        }
      }
      return true
    },
    criteria (opt, index) {
      // filter criteria to store to allow filtering to happen on the main page
      // as well as preserve filter state
      this.filters[this.drawerSelecting].fmap[index] = opt.name
      return index
    },
    clearFilters () {
      console.log('clearing filters')
      this.drawerError = ''
      if (this.drawerSelecting == 'dates') {
        this.filterDates.to = ''
        this.filterDates.from = ''
      }
      this.filters[this.drawerSelecting].selected = {}
      this.doFiltering()
    },
    doFiltering () {
      if (this.checkBounds()) {
        const filtersToApply = this.collectFilters(this.filters, this.filterDates)
        this.filteredDeadlines = this.applyFilters(filtersToApply, this.deadlines)
        this.hideDrawer()
      }
    },
    cancelFilterChanges () {
      console.log('restoring from filter snapshot')
      this.filters = JSON.parse(JSON.stringify(this.filterSnapshot))
      this.filterDates.from = this.filterDatesSnapshot.from
      this.filterDates.to = this.filterDatesSnapshot.to
      this.filterSnapshot = {}
      this.filterDatesSnapshot = {}
      this.hideDrawer()
    },
    hideDrawer () {
      this.drawerError = ''
      this.showDrawer = false
    },
    loadFilter (f) {
      this.collectDrawerContents(f)
      console.log('taking filter snapshot')
      this.filterSnapshot = JSON.parse(JSON.stringify(this.filters))
      this.filterDatesSnapshot.from = this.filterDates.from
      this.filterDatesSnapshot.to = this.filterDates.to
      this.showDrawer = true
    },
    filterEvents (type) {
      /* 'filtering' the display to show Deadlines or Grades (nothing to do with UserFilters) */
      if (type === 'deadlines') {
        this.selected = [true, false, false]
        this.showDeadlines = true
        this.showGrades = false
        if (this.$route.path != '/deadlines/0') {
          this.$router.push('/deadlines/0')
        }
      } else if (type == 'grades') {
        this.selected = [false, true, false]
        this.showDeadlines = false
        this.showGrades = true
        if (this.$route.path != '/deadlines/1') {
          this.$router.push('/deadlines/1')
        }
      } else {
        this.selected = [false, false, true]
      }
    },
    collectDrawerContents (f) {
      // filter name is one of dates, course, topic, status, type
      let dc = {}
      this.drawerSelecting = f.name

      this.drawerTitle = this.displayName(f)
      if (f.name === 'dates') {
        dc = [{
          'id': 0,
          'name': 'This week',
          'displayName': 'This week'
        },
        {
          'id': 1,
          'name': 'This month',
          'displayName': 'This week'
        },
        {
          'id': 2,
          'name': 'Range',
          'displayName': 'Range'
        }]
      } else {
        const propNames = this.propertyForFilter(f.name)
        if (typeof propNames === 'undefined') {
          console.log('no property name corresponds to filter name ' + f.name + '!!')
        }
        let ctr = 0
        const statusOrder = ['submission not open', 'submit', 'overdue', 'not submitted', 'graded', 'individual components']
        let sortFn = (a, b) => { return a.localeCompare(b) } // default sort
        if (f.name === 'status') {
          console.log('need a different sort')
          sortFn = (a, b) => { return statusOrder.indexOf(a) - statusOrder.indexOf(b) }
        }
        let choices = this.deadlines.map(deadline => (this.getPropContent(deadline, propNames)))
          .sort(sortFn)
          .filter(this.onlyUnique)
        dc = choices.map(c => ({ 'id': ctr++, 'name': c, 'displayName': this.capitalise(c) }))
      }
      this.drawerContents = dc
    },
    getPropContent (deadline, propNames) {
      // given a deadline object, the regular prop and optional extra propx
      // it will fetch the value of the regular prop from the object AND
      // if the extra props exist it will concatenate their values with a '|'
      let ret = ''
      const propValues = propNames.map(pn => deadline[pn])
      ret = propValues.join('|')
      return ret
    }
  }
}
</script>
<style>
.dateActive {
    background: linear-gradient(0deg, #E8ECF2, #E8ECF2);
    border-bottom: 4px solid #951272;
    color: var(--uog-dark-blue);
    font-weight: 900;
}
/* below inherits from another .eventNavUl */
/*
.eventNavUl {
    padding-left: 5% !important;
    padding-right: 5% !important;
    border-bottom: 0px !important;
}
*/
.eventNav {
    width: 30% !important;
    /* below inherits from another .eventNav */
    /*text-align: center;
    line-height: 50px;
    height: 50px;*/
}
.drawerError {
  color: firebrick;
}
.notifActionText {
    float: left;
    margin-left: 16px;
    margin-top: 32px;
    color: #4F5961;
}
.af-drawer-list-options {
  width: 100%;
}
.af-drawer-list-options {
  font-size: 18px;
}
.af-drawer-list-options tr td:first-child {
  width: 20px;
  padding-right: 10px;
}

.af-drawer-button-div {
  text-align: center;
}
.af-button-apply:disabled {
  opacity: 0.5;
}
.af-button-apply {
  border: var(--uog-dark-blue) solid 1px;
  border-radius: 8px;
  background-color: var(--uog-dark-blue);
  color: #ffffff;
  margin-top: 16px;
  margin-bottom: 10px;
  width: 85%;
  height: 40px;
}
.af-button-clear {
  border: none;
  background-color: #ffffff;
}
.refreshButtonContainer {
  margin-bottom: 50px;
  text-align: center;
}
.refreshButton {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    color: #FFFFFF;
    height: 35px;
    width: 70px;
    background: var(--uog-dark-blue);
    border-radius: 12px;
    border-color: var(--uog-dark-blue);
    border-style: solid;
}
.refreshButton:disabled {
  opacity: 0.4;
}
</style>
